import script from "./CustomListsBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomListsBlock.vue?vue&type=script&setup=true&lang=ts"

import "./CustomListsBlock.vue?vue&type=style&index=0&id=5399c86a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5399c86a"]])

export default __exports__